import { z } from 'zod';
import { AddonProduct } from '@/constants/AddonProduct';

export const employmentStatusSchema = z.enum([
  'Employed',
  'Student',
  'Retired',
  'SelfEmployed',
  'TemporarilyEmployed',
  'Unemployed',
]);

export const loanPurposeSchema = z.enum([
  'CONSUMPTION',
  'VEHICLE_AND_TRANSPORT',
  'RENOVATION_AND_HOUSING',
  'DEBT_CONSOLIDATION',
]);

export const housingTypeSchema = z.enum(['OWNED_HOUSE', 'OWNED_APARTMENT', 'RENTAL_APARTMENT', 'LODGER']);

const livingSchema = z.object({
  // The backend sends null until a housing type is chosen, and older records omit the key.
  housingType: housingTypeSchema.nullish(),
  numberOfChildren: z.number().min(0).max(3),
  numberOfPersonsLiving: z.number().min(1).max(2),
});

export const applicantResponseSESchema = z.object({
  id: z.string(),
  email: z.email(),
  mobile: z.string(),
  nationalNumber: z.string(),
  employmentStatus: employmentStatusSchema.nullable(),
  loanPurpose: loanPurposeSchema.nullable(),
  living: livingSchema.nullable(),
  finances: z
    .object({
      monthlyHouseCost: z.number(),
      otherLoanCost: z.number(),
      // Some existing users don't have these fields, as it was added later. Therefore, they are optional.
      monthlyGrossIncome: z.number().optional(),
      transportationCost: z.number().optional(),
    })
    .nullable(),
  addonProducts: z
    .array(z.enum([AddonProduct.PAYMENT_PROTECTION_INSURANCE, AddonProduct.ID_PROTECT]))
    .nullable(),
});
